<template>
  <tk-container
    :status="status"
    @refresh="init"
    class=""
  >
    <!-- 固定部分 -->
    <div
      slot="header"
      class="w-full px-15 pt-15 mb-10"
    >
      <global-title />
      <!-- 搜索 -->
      <div
        class="mt-15"
      >
        <van-field
          v-model="value"
          label=""
          right-icon="search"
          readonly
          class="rounded-10"
          style="padding-top: 8px !important;
            padding-bottom: 8px !important;"
          placeholder="请输入您想要搜索的内容"
          @click="$push('/common/search')"
        />
      </div>
    </div>
    <!-- 轮播 -->
    <div class="h-8" />
    <div
      v-if="swipeList.length > 0"
      class="px-15"
    >
      <swipe-card
        :data="swipeList"
      />
    </div>
    <!-- 滚动部分sticky -->
    <van-tabs
      v-model="active"
      swipeable
      color="#FC6554"
      :line-width="19"
      :line-height="4"
      class="bg-white"
      :ellipsis="false"
    >
      <van-tab
        v-for="(item, index) in classifiList"
        :key="index"
        :title="item.classificationName"
        class="px-15"
      >
        <van-row
          v-if="item.data && item.data.length > 0"
          :gutter="10"
          class="mt-12 pb-15"
        >
          <van-col
            v-for="(course, m) in item.data"
            :key="`${course.objectId}${m}`"
            class="mb-10"
            span="12"
          >
            <course-card :data="course" />
          </van-col>
        </van-row>
        <global-empty
          v-else
          word="没有找到相关内容～"
          :top="80"
          :bottom="100"
        />
      </van-tab>
    </van-tabs>
  </tk-container>
</template>

<script>
export default {
  data () {
    return {
      status: 'loading',
      value: '',
      swipeList: [],
      active: 0,
      classifiList: [],
    }
  },

  mounted () {
    this.init()
  },
  methods: {
    async init () {
      try {
        this.searchSwipes()
        await this.searchClassification()
        await this.classifiCourse()
        this.status = false
      } catch (e) {
        this.status = false
      }
    },
    async searchSwipes () {
      this.swipeList = []
      this.swipeList = await this.$tkParse.getList('/classes/rotationChartManagement')
    },
    async searchClassification () {
      this.classifiList = []
      this.classifiList = await this.$tkParse.getList('/classes/courseClassification')
    },
    async classifiCourse () {
      if (!this.classifiList.length) { return }
      const batchRequest = []
      for (let i = 0; i < this.classifiList.length; i++) {
        this.classifiList[i].data = []
        const request = this.$tkParse.getList('/classes/courseList', {
          params: {
            limit: 500,
            order: 'createdAt',
            where: {
              category: this.classifiList[i].objectId,
            },
          },
        })
        batchRequest.push(request)
      }
      let result = await Promise.all(batchRequest)
      for (let i = 0; i < result.length; i++) {
        this.classifiList[i].data = result[i]
      }
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .van-icon-search {
    font-weight: bold !important;
    color: #272636 !important;
  }
  .van-field__control:read-only {
    cursor: pointer;
  }
}
</style>
